// Educabolivia/src/components/Messages.js
import React from 'react';

const Messages = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="flex flex-col md:flex-row gap-6">
        {/* Columna izquierda */}
        <div className="md:w-1/3 bg-white rounded-lg shadow-sm p-4">
          <div className="flex justify-between items-center mb-6">
            <h1 className="text-2xl font-bold text-gray-800">MENSAJES</h1>
            <span className="text-sm text-gray-500">Tienes 0 mensajes sin leer</span>
          </div>

          <button className="w-full mb-6 px-4 py-2 bg-purple-600 text-white rounded hover:bg-purple-700">
            Redactar
          </button>

          <div className="mb-6">
            <div className="relative">
              <input
                type="text"
                placeholder="Buscar mensajes"
                className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-full focus:outline-none focus:ring-2 focus:ring-purple-600"
              />
              <svg className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
              </svg>
            </div>
          </div>

          <nav>
            <ul className="space-y-2">
              <li>
                <button className="w-full text-left px-4 py-2 bg-purple-100 text-purple-700 rounded font-medium">
                  Todos los mensajes
                </button>
              </li>
              <li>
                <button className="w-full text-left px-4 py-2 hover:bg-gray-100 rounded">
                  No leídos
                </button>
              </li>
              <li>
                <button className="w-full text-left px-4 py-2 hover:bg-gray-100 rounded">
                  Sin respuesta
                </button>
              </li>
              <li>
                <button className="w-full text-left px-4 py-2 hover:bg-gray-100 rounded">
                  Importantes
                </button>
              </li>
            </ul>
          </nav>
        </div>

        {/* Columna derecha */}
        <div className="md:w-2/3 bg-white rounded-lg shadow-sm p-8 flex flex-col items-center justify-center">
          <div className="text-center">
            <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
            </svg>
            <h3 className="mt-2 text-lg font-medium text-gray-900">No tienes ningún mensaje</h3>
            <p className="mt-1 text-gray-500">Selecciona una cadena de mensajes para leerla aquí.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Messages;